import React from "react";
import styles from "./savior-desc-modal.module.css";
import ModalLeft from "./modal-left/modal-left";
import ModalRight from "./modal-right/modal-right";

export default function SaviorDescModal({ lang, isActive, setIsActive, selected, next, prev }) {
    return (
        <div className={`modal ${isActive ? "active" : ""}`}>
            <div className="window">
                <button className="close-button" onClick={() => setIsActive(false)}>
                    <i className="fi fi-sr-x" />
                </button>
                {/* <button className={`${styles["nav-btn"]} ${styles["prev"]}`}></button>
            <button className={`${styles["nav-btn"]} ${styles["next"]}`}></button> */}

                {/* <!-- Left Column: Illust & Arc Point --> */}
                {selected && <ModalLeft lang={lang} savior={selected} />}

                {/* <!-- Right Column: Profile, Stats, Skills --> */}
                {selected && <ModalRight lang={lang} savior={selected} />}
            </div>
        </div>
    );
}
